<page-grid [gridConfig]="servicesGrid" (gridClickColumn)="openDialog($event)">
    @if(isLoggedInUserHasManagerRole){
        <ng-template #actionItem let-item="item">
            @if(item.tasks.length === 0) {
                <button id="booking-hs-tickets-button-create" mat-raised-button (click)="upsertHsTicket(item, 'create')">Create</button>

            }
            @if(item.tasks.length > 0) {
                <button id="booking-hs-tickets-button-update" mat-raised-button (click)="upsertHsTicket(item, 'update')">Update</button>

            }
        </ng-template>
    }
</page-grid>
